export const FORM_LABELS = {
  email: "Email",
  emailOrName: "Email",
  password: "Password",
  adminLoginTitle: "Admin Login",
  adminLoginSubtitle: "Sign in to access the admin dashboard",
  submit: "Sign In as Admin",
};


export const TICKETfIELDS = [
  { name: "PNR", label: "PNR", type: "text" },
  { name: "airline", label: "Airline", type: "text" },
  { name: "flightNumber", label: "Flight Number", type: "text" },
  { name: "departureLocation", label: "Departure Location", type: "location" },
  { name: "arrivalLocation", label: "Arrival Location", type: "location" },
  { name: "dateOfJourney", label: "Date of Journey", type: "date" },
  { name: "departureTime", label: "Departure Time", type: "time" },
  { name: "arrivalTime", label: "Arrival Time", type: "time" },
  { name: "totalSeats", label: "Total Seats", type: "number" },
  { name: "purchasePrice", label: "Purchase Price", type: "number" },
  { name: "purchaseDate", label: "Purchase Date", type: "date" },
  { name: "dateOfNameSubmission", label: "Name Submission Date", type: "date" },
  { name: "advPaidAmount", label: "Advance Paid Amount", type: "number" },
  { name: "outstanding", label: "Outstanding Amount", type: "number" },
  { name: "outstandingDate", label: "Outstanding Date", type: "date" },
  { name: "totalPrice", label: "Total Price", type: "number" },
  { name: "salePrice", label: "Sale Price", type: "number" },
  { name: "release", label: "Release Status", type: "number" },
  { name: "Discount", label: "Discount", type: "number" },
];
